import SectionFirstPage from '@/components/common/SectionFirstPage';
import SectionService from '@/components/pages/SoftwareDevelopmentService/SectionService';
import SectionTechnologies from '@/components/pages/SoftwareDevelopmentService/SectionTechnologies';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SoftwareDevelopmentService = () => {
  const { t } = useTranslation();
  return (
    <div>
      <SectionFirstPage
        title={
          <h1>
            {t('Software')}
            <br />
            {t('Development')}
            <br />
            <span>{t('Service')}</span>
          </h1>
        }
        desc={t(
          'Warppipe delivers high-quality software development services through a cost-effective outsourcing model. Our skilled team ensures smooth collaboration from idea to launch, providing reliable and tailored tech solutions'
        )}
      />
      <SectionService />
      <SectionTechnologies />
    </div>
  );
};

export default SoftwareDevelopmentService;
